import React from 'react'
import { Stepper } from 'src/components/atoms/stepper'

export const StepperWrapper: React.FC<{ currentPage: string, currentStep: number }> = props => {
  const { currentPage = '', currentStep = 1 } = props
  return (
    <div className={'bg-[#020409] flex py-[16px] border-b-[1px] border-[#171B21] items-center justify-center'}><Stepper currentStep={currentStep} currentPage={currentPage}/></div>)
}
